import { Stack, Typography, Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import BranchListTable from './BranchMangTable';
import AddIcon from '@mui/icons-material/Add';
import AddEditBranchModal from './AddNewBranchModal';
import { endpoints } from '../../api/endpoints';
import { useCrudForm } from '../../api/useCrudForm';
import { AddLookUpBtn } from '../../components/styledComponent/Button';
import { AppContext } from '../../contexts/AppContext';

const BranchManagement = () => {

  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any | null>()
  const [branchList, setBranchList] = useState<any | null>()
  const [isView, setIsView] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState(0)
  const [count, setCount] = useState<any>(0);
  const [take, setTake] = useState(10)
  const { user } = useContext(AppContext)

  const { get } = useCrudForm();

  const refetchData = () => {
    get({
      endpoints: `${endpoints.branch.list}?skip=${skip * take}&take=${take}`,
      onSuccess: (data: any) => {
        setLoading(false)
        setBranchList(data.data.list)
        setCount(data.data.count)
      },
      onError: (error: any) => {
        setLoading(false)

        console.log(error)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    refetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, take])

  return (
    <>
      <Typography variant="h5" component="h5" mb={1} fontWeight={600}>
        Branch Management
      </Typography>
      <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        {user?.IsSuperAdmin ?
          <Stack direction="row" mb={3} spacing={2} sx={{ justifyContent: "end", alignItems: "center" }}>
            <AddLookUpBtn onClick={() => setOpen(true)}>
              <AddIcon />
              <Typography sx={{ fontSize: '14px' }}>New Branch</Typography>
            </AddLookUpBtn>
          </Stack>
          : null}
        <BranchListTable isSuperAdmin={user?.IsSuperAdmin} refetchData={refetchData} loading={loading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} setOpen={setOpen} setSelectedItem={setSelectedItem} rows={branchList} setBranchList={setBranchList} setIsView={setIsView} />
      </Box>
      <AddEditBranchModal refetchData={refetchData} setIsView={setIsView} isView={isView} open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
    </>
  )
}

export default BranchManagement
